import type { SnEvent } from '../../features/event/types'
import { fetchAllEventPages } from './fetchAllEventPages'

/**
 * Query params for a schedule's event list.
 *
 * The same filters `/events/membership` takes, minus `schedule_id` — the
 * schedule is the path here, not a filter. The competition schedule sends the
 * same values to its games request, so the two lists stay bounded alike.
 *
 * Every field is optional: an absent key means "no filter", which is not the
 * same as sending an empty one.
 */
export interface ListScheduleEventsQuery {
  team_id?: string
  organization_id?: string
  venue_id?: string
  facility_id?: string
  /** Include events on the schedule's descendants (its divisions). */
  recursive?: number
  starts_after?: string
  starts_before?: string
  order?: string
  per_page?: number
  sport_id?: string
  generic_sport_id?: string
  /** Free-text search. */
  query?: string
}

/**
 * Every event on a schedule — a competition, season or division.
 *
 * REPLACED `/events/membership` for the competition schedule list. That
 * endpoint answers for the events the CURRENT USER has a membership claim on,
 * so anyone browsing a competition they are not rostered in — a league admin
 * most of all — saw an empty list where events plainly existed. This one is
 * scoped by the schedule itself, so it answers the question the page actually
 * asks.
 *
 * `/events/membership` remains in use for My Schedule, where membership
 * scoping is the point: that page is by definition the viewer's own.
 *
 * Fully paginated — see `fetchAllEventPages` for why the list must be complete.
 */
export const listScheduleEvents = async (
  scheduleId: string,
  query: ListScheduleEventsQuery = {}
): Promise<SnEvent[]> =>
  fetchAllEventPages(`/schedules/${scheduleId}/events`, query)
